import { render } from "./MyDialog.vue?vue&type=template&id=c9aa6634&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"

import "./MyDialog.vue?vue&type=style&index=0&id=c9aa6634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9aa6634"]])

export default __exports__